// Rider height in inches, from what people type (same reading as
// server/helpers/rentals.js parseHeight): 5'7", 5 ft 7, 5-7, 67, 170 cm.
export function parseHeight(text) {
  const t = String(text == null ? '' : text).toLowerCase().trim();
  if (!t) return null;
  let m = t.match(/^(\d{2,3}(?:\.\d+)?)\s*cm$/);
  if (m) return Math.round(Number(m[1]) / 2.54);
  m = t.match(/^(\d)\s*(?:'|′|ft|feet|foot|-|\s)\s*(\d{1,2}(?:\.\d+)?)?\s*(?:"|″|''|in|inches)?$/);
  if (m) { const inch = Number(m[2] || 0); return inch < 12 ? Number(m[1]) * 12 + Math.round(inch) : null; }
  m = t.match(/^(\d{2})(?:\s*(?:"|″|in|inches))?$/);
  if (m) { const n = Number(m[1]); return n >= 36 && n <= 90 ? n : null; }
  return null;
}
export const heightLabel = (inches) => (inches == null || inches === '' ? '' : `${Math.floor(inches / 12)}′${inches % 12}″`);
